'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input } from 'dumb';
import { TableList, TableListRow, TableListCell } from 'dumb/tables/table-list';

// phrases
import phrases from './../../../posConfigurationIngredientPricingVariation.phrases';

// lodash
import _get from 'lodash/get';

class IngredientVariationPricingStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		// get value from event
		const value = e.target ? e.target.value || e.target.checked : e;

		// edits the row in the store
		this.props.editBatchListItem({
			...row,
			...{ [type]: value },
		});
	}

	render() {
		const { batchList } = this.props;

		return (
			<TableList>
				<thead>
					<tr>
						<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
						<th>{phrases.MODAL_BATCH_STEP_POS_CONFIGURATION_VERSION}</th>
						<th>{phrases.MODAL_BATCH_STEP_INGREDIENT_VARIANT}</th>
						<th>{phrases.MODAL_BATCH_STEP_SORT_ORDER}</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{batchList.map((entry, i) => {
						return (
							<TableListRow key={entry.identifier}>
								<TableListCell>{i + 1}</TableListCell>
								<TableListCell>
									{_get(entry, 'posConfigurationVersion.name', '')}
								</TableListCell>
								<TableListCell>
									<Input
										id={`ingredientVariant-${i}`}
										value={entry.ingredientVariant || ''}
										onChange={(event) =>
											this._editListEntry(event, entry, 'ingredientVariant')
										}
									/>
								</TableListCell>
								<TableListCell>
									<Input
										id={`sortOrder-${i}`}
										value={entry.sortOrder || ''}
										onChange={(event) =>
											this._editListEntry(event, entry, 'sortOrder')
										}
									/>
								</TableListCell>
								<TableListCell>
									<Button
										type="negative"
										size="tiny"
										onClick={() => this._onRemoveEntry(entry.identifier)}>
										<span className="icon icon--delete" />
									</Button>
								</TableListCell>
							</TableListRow>
						);
					})}
				</tbody>
			</TableList>
		);
	}
}

IngredientVariationPricingStepList.propTypes = {
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
};

IngredientVariationPricingStepList.defaultProps = {};

export default IngredientVariationPricingStepList;
